// @ts-ignore Ignore unused commented ActionTypes import
import { AppActionTypes, TemplateActions } from './actions';
import { AppState } from '../shared/models';

export const initialState: AppState = {
  templateFilter: {
    cropId: null,
    soilTypeId: null,
    isCorrupt: null,
    templateType: null,
    provinces: null,
    cropAidId: null,
  },
};

// add switch cased to the reducer for every action
// or combine reducers from the reducers subfolder right here
export function appReducer(state: AppState = initialState, action: TemplateActions): AppState {
  switch (action.type) {
    case AppActionTypes.SetTemplates: {
      return {
        ...state,
        templates: [...action.templates],
        templatePagination: action.pagination,
      };
    }

    case AppActionTypes.SetTemplate: {
      return {
        ...state,
        templates: [action.template],
      };
    }

    case AppActionTypes.SetCrops: {
      return {
        ...state,
        crops: [...action.cropVarieties],
      };
    }

    case AppActionTypes.SetDefaultCropYear: {
      return {
        ...state,
        defaultCropYear: action.cropYear,
      };
    }

    case AppActionTypes.SetCropYear: {
      return {
        ...state,
        cropYear: action.cropYear,
      };
    }

    case AppActionTypes.SetAvailableCropYears: {
      return {
        ...state,
        availableCropYears: action.availableCropYears,
      };
    }

    case AppActionTypes.SetSalesOrderPeriods: {
      return {
        ...state,
        salesOrderPeriods: action.salesOrderPeriods,
      };
    }

    case AppActionTypes.UpdateTemplateFilter: {
      return {
        ...state,
        templateFilter: {
          ...state.templateFilter,
          ...action.templateFilter,
        },
      };
    }

    case AppActionTypes.ClearTemplateFilter: {
      return {
        ...state,
        templateFilter: {
          cropId: null,
          soilTypeId: null,
          isCorrupt: null,
          templateType: null,
          provinces: null,
          cropAidId: null,
        },
      };
    }

    case AppActionTypes.SetCropYearInStore: {
      return {
        ...state,
        cropYear: action.cropYear,
      };
    }

    case AppActionTypes.SetNutrientProperties: {
      return {
        ...state,
        nutrientProperties: action.nutrientProperties,
      };
    }

    case AppActionTypes.SetSoilTypes: {
      return {
        ...state,
        soilTypes: action.soilTypes,
      };
    }

    case AppActionTypes.SetUnitsOfMeasure: {
      return {
        ...state,
        unitsOfMeasure: action.unitsOfMeasure,
      };
    }

    case AppActionTypes.SetNutrientDesignations: {
      return {
        ...state,
        nutrientDesignations: action.nutrientDesignations,
      };
    }

    case AppActionTypes.SetNutrientSources: {
      return {
        ...state,
        nutrientSources: action.nutrientSources,
      };
    }

    case AppActionTypes.SetVarietyProperties: {
      return {
        ...state,
        varietyProperties: action.varietyProperties,
      };
    }

    case AppActionTypes.SetCropVarieties: {
      return {
        ...state,
        cropVarieties: action.cropVarieties,
      };
    }

    case AppActionTypes.SetProductionPurposeCategories: {
      return {
        ...state,
        productionPurposeCategories: action.productionPurposeCategories,
      };
    }
    case AppActionTypes.SetProductionPurposeCategoriesDetailed: {
      return {
        ...state,
        productionPurposeCategoriesDetailed: action.productionPurposeCategoryDetailed,
      };
    }
    case AppActionTypes.SetNitrogenModelProperties: {
      return {
        ...state,
        nitrogenModelProperties: action.nitrogenModelProperties,
      };
    }
    default:
      return state;
  }
}
